import React from 'react';
import Tag from 'sushiweb/Tag';
import Title from './Title';

function Item({ details }) {
  return (
    <div
      css={`
        font-size: ${details?.font_size || '1.2rem'};
        font-weight: ${details?.font_size || '600'};
        display: flex;
        flex-direction: row;
        gap: ${details?.gap || '1rem'};
      `}
    >
      <span
        className='tw-rounded-lg tw-bg-base-white tw-h-20 tw-flex tw-justify-center tw-items-center tw-w-20 tw-aspect-square '
        role='img'
        aria-label='item'
      >
        <img
          src={details?.image}
          alt='item'
          width='100%'
          height='100%'
          className='tw-rounded-lg'
        />
      </span>
      <div
        css={`
          display: flex;
          flex-direction: row;
          width: 80%;
        `}
      >
        <div
          css={`
            display: flex;
            flex-direction: column;
            width: 80%;
          `}
        >
          <Title details={{ title: details?.title }} />
          <Title
            details={{
              title: details?.subtitle,
              font_size: '1.2rem',
              font_weight: '500',
            }}
          />
        </div>
        {details?.tags.length > 0 && (
          <div className='tw-flex tw-w-[30%] tw-justify-end'>
            {details?.tags.map((tag) => (
              <Tag
                type='tag'
                key={tag.text}
                label={tag.text}
                bgColor={tag.bg_color}
                textColor={tag.color}
                fontSize={tag?.font_size || '1rem'}
                margin='0.3rem 1rem'
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Item;
